var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#0F5BF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 46.7505C37.625 40.4505 43.75 34.8093 43.75 27.8505C43.75 20.8917 38.2655 15.2505 31.5 15.2505C24.7345 15.2505 19.25 20.8917 19.25 27.8505C19.25 34.8093 25.375 40.4505 31.5 46.7505Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 32.7505C34.3995 32.7505 36.75 30.4 36.75 27.5005C36.75 24.601 34.3995 22.2505 31.5 22.2505C28.6005 22.2505 26.25 24.601 26.25 27.5005C26.25 30.4 28.6005 32.7505 31.5 32.7505Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.39e96ae66aba1d7abd2fb1d4870f1d08.svg";
export { ForwardRef as ReactComponent };